import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-rise",
  "use": "icon-rise-usage",
  "viewBox": "0 0 20 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 12\" fill=\"none\" id=\"icon-rise\"><path id=\"icon-rise_Path\" fill-rule=\"evenodd\" style=\"fill:#A5B557\" transform=\"translate(0 0)  rotate(0 10 6)\" opacity=\"1\" d=\"M1.41 12L0 10.59L7.41 3.17L11.41 7.17L16.29 2.29L14 0L20 0L20 6L17.71 3.71L11.41 10L7.41 6L1.41 12Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol